import { NgModule, ComponentRef, Injectable } from "@angular/core";
import {
  RouterModule,
  DetachedRouteHandle,
  ActivatedRouteSnapshot,
  RouteReuseStrategy,
} from "@angular/router";
import { FileUploadStatusEnum } from './shared/models/order.model';

@NgModule({
  exports: [RouterModule],
})
export class AppRoutingModule {}

@Injectable()
export class CustomRouteReuseStrategy implements RouteReuseStrategy {
  //private handlers: { [key: string]: DetachedRouteHandle } = {};
  private handlers: Map<string, DetachedRouteHandle> = new Map();

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    if (!route.routeConfig || route.routeConfig.loadChildren) {
      return false;
    }

    if (route.queryParams){
      if (route.queryParams.reuse){
        return false;
      }
    }
    
    let shouldReuse = false;
    if (route.routeConfig.data) {
      route.routeConfig.data.reuse
        ? (shouldReuse = true)
        : (shouldReuse = false);
    }
    return shouldReuse;
  }

  store(route: ActivatedRouteSnapshot, handler: DetachedRouteHandle): void {
    if (handler) {
      //this.handlers[this.getUrl(route)] = handler;
      this.handlers.set(this.getUrl(route), handler);
    }
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    if (this.shouldResetReuseStrategy(route)) {
      this.deactivateAllHandles();
      return false;
    }

    if (route.queryParams){
      if (route.queryParams.reuse){
        return false;
      }
    }

    //return !!this.handlers[this.getUrl(route)];
    return !!this.handlers.has(this.getUrl(route));
  }

  private deactivateAllHandles(): void {
    this.handlers.forEach((handle: DetachedRouteHandle) =>
      this.destroyComponent(handle)
    );
    this.handlers.clear();
  }

  private destroyComponent(handle: DetachedRouteHandle): void {
    const componentRef: ComponentRef<any> = handle["componentRef"];

    if (componentRef) {
      componentRef.destroy();
    }
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
    if (!route.routeConfig || route.routeConfig.loadChildren) {
      return null;
    }

    return this.handlers.get(this.getUrl(route));
  }

  shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    current: ActivatedRouteSnapshot
  ): boolean {
    let reUseUrl: string;

    if (future.routeConfig) {
      if (future.routeConfig.data) {
        reUseUrl = future.routeConfig.data.reuse;
      }
    }

    const defaultReuse = future.routeConfig === current.routeConfig;

    if (current.routeConfig)
      return reUseUrl == current.routeConfig.path || defaultReuse;
    else return defaultReuse;
  }

  getUrl(route: ActivatedRouteSnapshot): string {
    if (route.routeConfig) {
      const url = route.routeConfig.path;
      return url;
    }
  }

  private shouldResetReuseStrategy(route: ActivatedRouteSnapshot): boolean {
    let snapshot: ActivatedRouteSnapshot = route;

    while (snapshot.children && snapshot.children.length) {
      snapshot = snapshot.children[0];
    }

    return snapshot.data && snapshot.data.resetReuseStrategy;
  }
}
